export const FORM_SUBMIT_STATUS = {
  SUBMITTING: 'SUBMITTING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

export const FORM_SUBMIT_STATUS_LIST = Object.values(FORM_SUBMIT_STATUS);

export const BAOSYSTEMS_DOMAIN = 'baosystems.com';
export const PURCHASE_DOMAIN = "purchaseDomain";
export const CUSTOMER_DOMAIN = 'customerDomain';
export const DEFAULT_SERVICE_PERIOD = '12';
export const BILLING_FREQUENCE_OPTIONS = [1, 3, 6, 12, 24];
